import React from "react";
import InputRequire from "views/components/InputRequire";

export const CoefficientInput = ({ 
  label = "Coefficient", 
  placeholder = "Veuillez entrer le Coefficient",
  values = [""], 
  onChange, 
  errors = [], 
  t 
}) => {

  // 1. Ajouter un nouveau champ vide au tableau
  const handleAddField = () => {
    onChange([...values, ""]);
  };

  // 2. Supprimer un champ à l'index donné
  const handleRemoveField = (index) => {
    const updated = values.filter((_, i) => i !== index);
    onChange(updated);
  };

  // 3. Mettre à jour la valeur d'un champ précis
  const handleItemChange = (index, newValue) => {
    const updated = [...values];
    updated[index] = newValue;
    onChange(updated);
  };

  return (
    <div className="col col-12 col-md-12 mb-4">
      {/* Entête de la section avec le Titre et le bouton "Nouveau champ" */}
      <div className="form-group row mb-4 d-flex justify-content-between align-items-center">
        <label className="font-weight-bold mb-0 col-8 col-lg-9">
          {t(label)} <InputRequire />
          <i 
            className="fa fa-info-circle ml-2" 
            data-toggle="tooltip" 
            data-placement="bottom"
            title={t(label)}
          ></i>
        </label>
        
        <button
          type="button"
          className="btn btn-sm btn-outline-success"
          onClick={handleAddField}
        >
          <i className="la la-plus m-0"></i> 
          {t("Ajouter")}
        </button>
      </div>

      {/* Génération dynamique des champs saisissables */}
      {values.map((val, index) => (
        <div key={index} className="form-group row mb-3 align-items-center">
          <div className="col-10">
            <input
              type="text"
              className={`form-control ${errors[index] ? "is-invalid" : ""}`}
              placeholder={t(placeholder)}
              value={val}
              onChange={(e) => handleItemChange(index, e.target.value)}
              style={{ height: 45 }}
            />
            {errors[index] && (
              <div className="invalid-feedback">{errors[index]}</div>
            )}
          </div>

          <div className="col-2 d-flex justify-content-center">
            {/* Le bouton supprimer s'affiche uniquement si plus d'un champ existe */}
            {values.length > 1 && (
              <button
                type="button"
                className="btn btn-sm btn-icon btn-outline-danger"
                onClick={() => handleRemoveField(index)}
              >
                <i className="la la-trash"></i>
              </button>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};
